import { useCallback, useMemo, useState , useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import {TabNavs} from "../../../index";
import Detail from "./detail";
import Gallery from "./gallery";
import Table from "./table";
import { useDispatch } from "react-redux";
import { getVehicleLocationHistory, setModalName, setSelectedVehicle } from "store/actions";
import Stats from "./stats";
import { useSelector } from "react-redux";
import { AppState } from "store";
import "styles/components/tab-content/vehicles-content/vehicle-detail.scss";
export type ComponentType = "gallery" | "stats";

export default function VehicleDetail() {
  const {
    vehicles: { selectedVehicle },
  } = useSelector<AppState, AppState>((state) => state);
  const [component, setComponent] = useState<ComponentType>("gallery");
  const history = useHistory();
  const dispatch = useDispatch();

  const onClickBack = useCallback(() => {
    history.goBack();
  }, [history]);

  const onAddIssue = useCallback(() => {
    dispatch(setModalName("add_issue_from_vehicle"));
  }, []);
  
  const onEditVehicle = useCallback(() => {
    dispatch(setModalName("edit_vehicle"));
  }, [dispatch]);
  
  const onArchiveVehicle = useCallback(() => {
    dispatch(setModalName("delete_vehicle"));
  }, [dispatch]);
  
  const onChangeComponent = useCallback((component: ComponentType) => {
    setComponent(component);
  }, []);

  const dynamicComponent = useMemo(() => {
    console.log("component : ", component)
    switch (component) {
      case "gallery":
        return (
          <Gallery
            onEditVehicle={onEditVehicle}
            onArchiveVehicle={onArchiveVehicle}
            onChangeComponent={onChangeComponent}
            onClickBack={onClickBack}
          />
        );
      default:
        return <Stats onChangeComponent={onChangeComponent}/>;
    }
  }, [component]);

  return (
    <main className="vehicle-detail-content">
      <div className="vehicle-detail-content__main">
        {dynamicComponent}
      </div>
      
      <aside className="vehicle-detail-content__sidebar">
        <Detail />
      </aside>

      {/* <Table onAddIssue={onAddIssue} /> */}
      {/* <TabNavs
        selected={selectedView}
        onChange={(value) => setSelectedView(value)}
        options={[{ key: "Location History"}, { key: "Battery Insert Data" }]}
      /> */}
      {/* <Table  /> */}
    </main>
  );
}